<template>
  <div>
    <div class="uk-cover-container">
      <BannerComponent :banner-url="`${ASSETS_BASE_URL}/images/inquiry/banner.jpg`" :title="'inquiry'|translate"/>
    </div>
    <div class="uk-container SectionOneInc">

      <div class="uk-grid-match uk-grid-small form-grid" uk-grid>
        <div class="uk-width-1-1@s">
          <p class="uk-text-center  uk-margin-medium-bottom">
            {{'inquiry_view.para_1'|translate}}
            <br><br>
            {{'inquiry_view.para_2'|translate}}
          </p>
        </div>
        <div class="uk-width-3-5@m uk-width-2-3@l">

          <div class="uk-card uk-card-default uk-card-body">
            <ValidationObserver v-slot="{ passes }">
              <form
                @submit.prevent="passes(sendInquiry)"
                class="uk-grid-small uk-form-stacked"
                uk-grid>
                <div class="uk-width-1-1">
                  <div class="uk-margin">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <label class="uk-form-label" for="property-select">
                        {{'inquiry_view.form.select_property'|translate}} *
                      </label>
                      <multiselect
                        id="property-select"
                        class="inquiry-input"
                        :class="`${errors.length > 0 ? 'error-required' : ''}`"
                        v-model="inquiryForm.properties"
                        :options="hotelOptions"
                        :placeholder="'inquiry_view.form.select_property_placeholder'|translate"
                        track-by="name"
                        label="name">
                        <span slot="noResult">
                          {{'inquiry_view.form.select_property_no_result'|translate}}
                        </span>
                      </multiselect>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="uk-width-1-3@s">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label class="uk-form-label" for="check-in-date">
                      {{'inquiry_view.form.check_in_date'|translate}} *
                    </label>
                    <date-picker
                      id="check-in-date"
                      class="date-inputs inquiry-input"
                      :class="`${errors.length > 0 ? 'error-required' : ''}`"
                      :popupStyle="pop"
                      style="width: unset!important; display: unset!important"
                      v-model="inquiryForm.check_in_date"
                      lang="en"
                      :first-day-of-week="1"
                      :placeholder="'inquiry_view.form.check_in_date_placeholder'|translate"/>
                  </ValidationProvider>
                </div>
                <div class="uk-width-1-3@s">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label class="uk-form-label" for="check-out-date">
                      {{'inquiry_view.form.check_out_date'|translate}} *
                    </label>
                    <date-picker
                      id="check-out-date"
                      class="date-inputs inquiry-input"
                      :class="`${errors.length > 0 ? 'error-required' : ''}`"
                      :popupStyle="pop"
                      style="width: unset!important; display: unset!important"
                      v-model="inquiryForm.check_out_date"
                      lang="en"
                      :first-day-of-week="1"
                      :placeholder="'inquiry_view.form.check_out_date_placeholder'|translate"/>
                  </ValidationProvider>
                </div>
                <div class="uk-width-1-3@s">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label class="uk-form-label" for="no-of-guests">
                      {{'inquiry_view.form.no_of_guests'|translate}} *
                    </label>
                    <input
                      id="no-of-guests"
                      class="uk-input inquiry-input"
                      :class="`${errors.length > 0 ? 'error-required' : ''}`"
                      v-model="inquiryForm.no_of_guests"
                      style="border-radius: 4px"
                      type="number"
                      min="1"
                      max="6"
                      :placeholder="'inquiry_view.form.no_of_guests_placeholder'|translate"/>
                  </ValidationProvider>
                </div>
                <div class="uk-width-1-3@s">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <label class="uk-form-label" for="name">
                      {{'inquiry_view.form.name'|translate}} *
                    </label>
                    <input
                      id="name"
                      class="uk-input inquiry-input"
                      :class="`${errors.length > 0 ? 'error-required' : ''}`"
                      v-model="inquiryForm.name"
                      style="border-radius: 4px"
                      type="text"
                      :placeholder="'inquiry_view.form.name_placeholder'|translate">
                  </ValidationProvider>
                </div>
                <div class="uk-width-1-3@s">
                  <ValidationProvider rules="required|email" v-slot="{ errors }">
                    <label class="uk-form-label" for="email">
                      {{'inquiry_view.form.email'|translate}} *
                    </label>
                    <input
                      id="email"
                      class="uk-input inquiry-input"
                      :class="`${errors.length > 0 ? 'error-required' : ''}`"
                      v-model="inquiryForm.email"
                      style="border-radius: 4px"
                      type="email"
                      :placeholder="'inquiry_view.form.email_placeholder'|translate">
                  </ValidationProvider>
                </div>
                <div class="uk-width-1-3@s">
                  <label class="uk-form-label" for="contact_no">
                    {{'inquiry_view.form.contact_no'|translate}}
                  </label>
                  <input
                    id="contact_no"
                    class="uk-input inquiry-input"
                    v-model="inquiryForm.contact_no"
                    style="border-radius: 4px"
                    type="text"
                    :placeholder="'inquiry_view.form.contact_no_placeholder'|translate">
                </div>
                <div class="uk-width-1-1@s">
                  <label class="uk-form-label" for="remarks">
                    {{'inquiry_view.form.remarks'|translate}}
                  </label>
                  <textarea
                    id="remarks"
                    name="message"
                    cols="40"
                    rows="3"
                    class="uk-input inquiry-input"
                    v-model="inquiryForm.remarks"
                    style="height: 100px; border-radius: 4px"
                    aria-invalid="false"
                    :placeholder="'inquiry_view.form.remarks_placeholder'|translate"></textarea>
                </div>
                <div class="uk-width-1-2@s">
                  <button
                    :disabled="inquiryForm.processing"
                    type="submit"
                    class="uk-button uk-button-primary uk-align-left@l inquiry-submit">
                    Send
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>

        <div class="uk-width-2-5@m uk-width-1-3@l uk-text-center">
          <div>
            <div class="uk-cover-container" tabindex="0">
              <canvas height="300"></canvas>
              <img :src="`${ASSETS_BASE_URL}/images/home/offer_1.jpg`" alt="" uk-cover>
            </div>
          </div>
          <div class="uk-card-default" style="padding-top: 10px">
            <h3 class="AppTitle">{{'inquiry_view.reservations'|translate}}</h3>
            <p><strong>D:&nbsp;(+94)112827527<br>M:&nbsp;(+94)770035464</strong></p>
            <p>
              <a href="mailto:info@homewindleisures.com">info@homewindleisures.com</a>
            </p>
          </div>
        </div>

      </div>

      <OurCollectionComponent/>

    </div>
  </div>
</template>

<script>
import BannerComponent from '../components/BannerComponent'
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
import { email, max_value as maxValue, min_value as minValue, required } from 'vee-validate/dist/rules'
import types from '../store/types'
import store from '../store'
import OurCollectionComponent from '../components/OurCollectionComponent'

extend('required', {
  ...required,
  message: 'required *'
})
extend('email', {
  ...email,
  message: 'valid email required *'
})
extend('min_value', {
  ...minValue,
  message: 'valid value required *'
})
extend('max_value', {
  ...maxValue,
  message: 'valid value required *'
})

export default {
  name: 'Inquiry',
  components: {
    OurCollectionComponent,
    BannerComponent,
    Multiselect,
    DatePicker,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      pop: {
        'left': '0px',
        'top': '0px'
      },
      hotelOptions: [
        { name: 'CASAMIA Nilaveli' },
        { name: 'Casamia Colombo' }
        // { name: 'Turtle Nest Ranawaka' }
      ]
    }
  },
  methods: {
    sendInquiry: function () {
      this.$store.dispatch(types.submitInquiry)
    }
  },
  computed: {
    inquiryForm: function () {
      return store.getters['inquiry/inquiryForm']
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .SectionOneInc {
    padding-top: 30px;
    padding-bottom: 80px;
  }

  .Title {
    padding-top: 25px;
    font-family: 'Kaushan Script', cursive !important;
  }

  .mx-input {
    height: 40px
  }

  .date-inputs > div > input {
    border-color: rgb(229, 229, 229);
  }

  .error-required, .error-required > .multiselect__tags, .error-required > div > input {
    border-color: RED !important;
  }

  .inquiry-input, .inquiry-input > .multiselect__tags, .inquiry-input > div > input {
    background: #fff9f6;
  }

  .inquiry-input > .multiselect__tags .multiselect__input, .multiselect__single {
    background: #fff0 !important;
  }

  .inquiry-submit {
    background: #cf0015;
  }

  .inquiry-submit:hover, .inquiry-submit:focus {
    background: #a50014;
  }

  .form-grid {
    margin-bottom: 40px;
  }
</style>
